<script lang="ts">
    import {Component, mixins, Prop, toNative, Watch} from 'vue-facing-decorator'
    import BookingPageBase from '~src/components/parts/bookingPageBase.src'
    import {TransferStoreMixin} from '@/mixins/TransferStoreMixin.vue'
    import {EventBus, RESET_BOOKING_DATA} from '@/utils/event-bus'
    import {isPrepareBookResultClean, prepareBookResult} from '@/utils/PrepareBookAdapter'
    import AddOnMixin from '@/components/booking/addOns/AddOnMixin.vue'
    import BookingPageMixin from '~src/mixins/BookingPageMixin.vue'
    import {TransferOrderSummaryMixin} from '@/components/transfers/mixins/TransferOrderSummaryMixin.vue'
    import {TransferBookingFieldsMixin} from '@/components/transfers/booking/mixins/TransferBookingFieldsMixin.vue'
    import {callComponentMethod} from '~/utils/vue-class-helpers'

    @Component({mixins: [BookingPageBase]})
    export class TransferBookingPageLayout extends mixins(
        TransferStoreMixin,
        TransferOrderSummaryMixin,
        TransferBookingFieldsMixin
    ) {
        @Prop() isReturnTransfer
        @Prop() returnTransferOffer

        extraServices = [[]]

        @Watch('isReturnTransfer')
        onReturnTransferChange(isReturnTransfer) {
            this.resetBookResponse()
            if (isReturnTransfer) {
                this.extraServices.push([])
            } else {
                this.extraServices.pop()
            }
        }

        prepareBookRequest(specifiedTouristBookingFields, includeOptionalTourists = false) {
            const prepareBookRequest = callComponentMethod(
                this,
                BookingPageMixin,
                'prepareBookRequest',
                specifiedTouristBookingFields,
                includeOptionalTourists
            )
            if (this.extraServices[0]?.length) {
                prepareBookRequest.extraServices = this.extraServices[0]
            } else {
                delete prepareBookRequest.extraServices
            }
            return this.filterPrepareBookRequest(prepareBookRequest)
        }

        async sendPrepareBookRequest(prepareBookRequest) {
            try {
                await this.productStore.prepareBook({
                    rq: prepareBookRequest,
                    isReturnTransfer: this.isReturnTransfer,
                    returnTransferExtraServices: this.extraServices[1],
                })

                /*let success = true
                if (this.isReturnTransfer) {
                    success = this.prepareBookResponseProcessing(
                        prepareBookResponse.transferReturnRs,
                        transfersStore.prepareBookReturnTransferRequest.offerKey,
                        transfersStore.prepareBookReturnTransferRequest
                    )
                }
                return (
                    success &&
                    this.prepareBookResponseProcessing(
                        prepareBookResponse.transferRs,
                        transfersStore.prepareBookRequest.offerKey,
                        transfersStore.prepareBookRequest
                    )
                )*/

                if (isPrepareBookResultClean(prepareBookResult(this.prepareBookResponse, this.offersData))) {
                    await this.paymentStepInit()
                }
            } catch (e) {
                return this.prepareBookErrorProcessing(e)
            }
        }

        async getPaymentOptions(loyaltyPointsOptions) {
            try {
                const rq = {
                    ...loyaltyPointsOptions,
                    convertToCurrency: persistentStore.currency,
                }

                if (this.isReturnTransfer) {
                    rq.basketKey = this.productStore.prepareBookResponse.basketKey
                } else {
                    rq.bookingKey = this.productStore.prepareBookResponse.bookingKey
                }

                await persistentStore.getPaymentOptions(rq)
            } catch (e) {
                this.$toast.warning(this.$t('error_message.get_payment_options_unknown_error'))
            }
        }

        //TODO Need Refactoring with base component
        async makeOfflinePayment() {
            try {
                const rq = {
                    paymentMethodId: this.paymentMethodId,
                    ...(this.corporatePolicyViolationCodeId && {
                        corporatePolicyViolationCodeId: this.corporatePolicyViolationCodeId,
                    }),
                    ...(this.dueToConfirmDateActive && {dueToConfirmDate: this.dueToConfirmDate}),
                }

                if (this.isReturnTransfer) {
                    rq.basketKey = this.productStore.prepareBookResponse.basketKey
                } else {
                    rq.bookingKey = this.productStore.prepareBookResponse.bookingKey
                }

                const bookRs = await persistentStore.book(rq)

                this.productStore.seats = [[], []]

                if (!persistentStore.selectedOrderId && !authStore.person) {
                    await this.$router.push({
                        name: this.productConfirmationPageName,
                        query: this.productConfirmationPageQuery(bookRs[0].orderId),
                    })
                } else {
                    await this.redirectAfterPayment(
                        bookRs[0].orderId,
                        this.productConfirmationPageName,
                        this.productConfirmationPageQuery(bookRs[0].orderId)
                    )
                    if (persistentStore.selectedOrderId) {
                        persistentStore.SET_SELECTED_ORDER_ID(null)
                        if (persistentStore.selectedDestination) {
                            persistentStore.SET_SELECTED_DESTINATION(null)
                        }
                    } else if (authStore.isB2B) {
                        EventBus.$emit(RESET_BOOKING_DATA)
                    }
                }
                return true
            } catch (e) {
                this.$toast.error(this.$t('error_message.unknown_booking_error'))
                return false
            }
        }

        productConfirmationPageQuery(orderId) {
            return {orderId, returnTransfer: this.isReturnTransfer}
        }

        initBookingKey() {
            callComponentMethod(this, AddOnMixin, 'initBookingKey')
            if (this.isReturnTransfer) {
                this.basketKey = this.prepareBookResponse.basketKey
            }
        }

        get hasExtraServices() {
            return false
        }

        get productSearchPageName() {
            return 'transfers'
        }

        get productConfirmationPageName() {
            return 'transferConfirmation'
        }

        get productName() {
            return 'transfer'
        }

        get productBookingPageName() {
            return 'transferBooking'
        }

        get corporatePolicyType() {
            return 'transfer'
        }

        get startDate() {
            return this.searchRequest.dateTime
        }
    }

    export default {...toNative(TransferBookingPageLayout), ssrRender: BookingPageBase.ssrRender}
</script>
